export const ONLINE_SESSION_TIMEOUT_MS = 30 * 60 * 1000;
export const DEFAULT_SESSION_WARNING_WINDOW_MS = 3 * 60 * 1000;
export const SESSION_WARNING_WINDOW_MS = Math.min(
  DEFAULT_SESSION_WARNING_WINDOW_MS,
  ONLINE_SESSION_TIMEOUT_MS,
);
